<template>
  <div>
    <section v-for="(building, index) in builds" :key="'b' + index">
      <h2 class="ph-2x pv-1x" v-if="list.length > 1">
        <i class="el-icon-office-building"></i>
        <span class="mh-1x">{{ building.buildingName }}</span>
      </h2>
      <ul>
        <li
          class="floor"
          :class="[theme]"
          v-for="(item, idx) in building.floorData"
          :key="'f' + idx"
        >
          <div class="flex-start">
            <h3 class="ph-3x pv-2x pointer" @click="toggleShow(item)">
              <i class="el-icon-coin"></i>
              <span class="mh-1x">{{ item.floorName }}</span>
              <i class="el-icon-arrow-down" v-show="!item.show"></i>
              <i class="el-icon-arrow-up" v-show="item.show"></i>
            </h3>
            <el-checkbox
              v-model="item.checked"
              @change="checkFloorRoom($event, item)"
              v-if="multiple"
            >
              <span class="white">全选</span>
            </el-checkbox>
          </div>

          <transition :name="`slider${Math.ceil(item.roomData.length / col)}`">
            <ul class="list" v-show="item.show">
              <li class="item" v-for="temp in item.roomData" :key="temp.roomNo">
                <!-- leased: 已租， person：有人，  leased: 已租有人，for-rent 待租， sos求救 -->
                <div
                  v-if="temp.basicstatus === 'on'"
                  class="room flex-between flex-col"
                  :class="{
                    rented: temp.rent === 'rented',
                    sos:
                      temp.sos == 'true' ||
                      temp.smoke == 'true' ||
                      temp.water == 'true' ||
                      temp.gas == 'true',
                  }"
                  @click="handleItem(temp)"
                >
                  <p class="num">{{ temp.roomNo }}</p>
                  <div class="flex-evenly res mv-1x">
                    <svg
                      v-if="temp.identity !== 'noPeople'"
                      t="1679910726260"
                      class="person"
                      viewBox="0 0 1024 1024"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      p-id="7924"
                      width="18"
                      height="18"
                    >
                      <path
                        d="M632.855273 565.992727c101.771636-47.080727 172.590545-149.317818 172.590545-267.869091 0-163.118545-133.678545-295.842909-298.007273-295.842909C343.202909 2.280727 209.454545 135.005091 209.454545 298.077091c0 118.597818 70.842182 220.834909 172.590545 267.915636C188.020364 622.336 44.311273 805.329455 38.469818 1024l46.615273 0 844.753455 0 46.638545 0C970.612364 805.329455 826.926545 622.336 632.855273 565.992727z"
                        fill="rgba(255,255,255, 0.6)"
                        p-id="7925"
                      ></path>
                    </svg>
                    <div v-if="temp.temp === '' || temp.temp == null">
                      <b class="she-shi-du"
                        >&nbsp;&nbsp;&nbsp;{{ temp.temperature }}
                        <span class="font-l">℃</span>
                      </b>
                    </div>
                    <div
                      v-else-if="temp.temp != '' && temp.temp != null"
                      style=""
                    >
                      <div style="text-align: right">
                        <b class="she-shi-du_small"
                          >5{{ temp.temperature }}
                          <span class="font-s">℃</span>
                        </b>
                      </div>
                      <div style="font-size: 10px; text-align: right">
                        <span style="color: aquamarine"
                          >{{ temp.temp
                          }}<span style="font-size: 8px">℃</span></span
                        >
                        &nbsp;
                        <span style="color: lightblue"
                          >{{ temp.humi
                          }}<span style="font-size: 8px">%</span></span
                        >
                      </div>
                    </div>
                  </div>
                  <!-- 状态图标 -->
                  <div class="flex-center icons">
                    <!-- 空调开 -->
                    <template v-if="temp.switchstate === 'on'">
                      <!-- 自动 auto -->
                      <svg
                        v-if="temp.windspeed == 'auto'"
                        t="1680169972297"
                        class="icon"
                        viewBox="0 0 1024 1024"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        p-id="20577"
                        width="24"
                        height="24"
                      >
                        <path
                          d="M343.134964 724.45563a44.688952 44.688952 0 0 0 11.721692-12.362723 115.38541 115.38541 0 0 0 9.157572-17.033084c2.56412-6.135573 5.12824-12.454298 7.783937-19.04775l32.051502-81.410817h206.961132l42.949014 108.242503a44.872104 44.872104 0 0 0 12.087995 19.505629 28.571625 28.571625 0 0 0 21.520295 6.685028c13.553207 0 22.161325-3.937756 25.824354-11.721693a36.630289 36.630289 0 0 0-0.824182-28.571625l-164.8363-433.611044a35.165077 35.165077 0 0 0-14.102661-18.315145 47.344648 47.344648 0 0 0-26.556959-6.685028 43.681619 43.681619 0 0 0-25.366475 6.685028 35.439804 35.439804 0 0 0-13.736359 18.315145L303.665827 687.275886c-5.677695 16.025751-5.677695 27.472717 0 32.875685a32.143078 32.143078 0 0 0 24.267567 9.157572 26.190657 26.190657 0 0 0 15.20157-4.853513zM507.696536 302.199975l89.011602 242.584088H418.593359z"
                          p-id="20578"
                          fill="rgba(255,255,255, 0.6)"
                        ></path>
                        <path
                          d="M754.401532 910.629073a462.640548 462.640548 0 0 1-657.42211-191.576411 468.501395 468.501395 0 0 1 2.380969-426.926017v-0.732605a19.68878 19.68878 0 0 0 1.556787-6.776604 22.619203 22.619203 0 0 0-22.619203-22.527628 21.795022 21.795022 0 0 0-21.062416 15.018419A526.1941 526.1941 0 0 0 0.000733 503.666563V511.999954a509.344167 509.344167 0 0 0 109.341412 316.210969l4.578786 5.76927a511.084105 511.084105 0 0 0 397.988089 190.019624H523.081258a509.985197 509.985197 0 0 0 253.481599-74.817365l30.128412 51.923434L836.728106 888.284597l-112.546562-29.853686z m160.165938-714.840087c-1.465212-1.92309-3.021999-3.754605-4.578786-5.677695A511.084105 511.084105 0 0 0 511.90902 0.000092h-11.263814A509.06944 509.06944 0 0 0 247.255182 75.000608l-30.128412-52.01501-29.945261 112.546562 112.546562 30.036837-30.219988-52.289737a462.548973 462.548973 0 0 1 657.422109 191.667986 468.318243 468.318243 0 0 1-2.014666 426.834441V732.605869a20.696113 20.696113 0 0 0-1.556787 6.776603 22.710779 22.710779 0 0 0 22.619204 22.619204 21.886598 21.886598 0 0 0 21.062416-15.109994 526.1941 526.1941 0 0 0 57.14325-226.558337v-0.64103-7.600785a509.06944 509.06944 0 0 0-109.616139-316.302544z"
                          p-id="20579"
                          fill="rgba(255,255,255, 0.6)"
                        ></path>
                      </svg>
                      <!-- 风速低 -->
                      <svg
                        v-else-if="temp.windspeed == 'low'"
                        t="1679650057641"
                        class="icon"
                        viewBox="0 0 1024 1024"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        p-id="9570"
                        width="24"
                        height="24"
                      >
                        <path
                          d="M691.4 129.4c18.2 0 36.3 3.7 52.3 10.6 14.2 6.2 26.3 14.9 34.2 24.4 11.8 14.5 9.7 25.2 8.9 28.8-6.6 32.2-18.6 47.4-28.4 57-14.9 14.6-36.1 26.5-60.7 40.1-23.5 13.1-50.2 27.9-78 48.9-12.1 9.1-23.2 19.2-33 29.9l-28.4 31.1-1.6-6.2c-10.3-40.3-14.4-77.3-12.1-110 2.6-36.2 13.2-67.2 31.5-92.2 15.8-21.6 34.6-37.9 55.9-48.5 18.6-9.2 38.6-13.9 59.4-13.9M566.7 432.8l37.1 16c31.6 13.6 51.9 44.6 51.9 79 0 1.8-0.1 3.8-0.2 5.8l-2.4 36.6-28.3 23.6c-15.6 13.1-34.7 20-55.1 20-16.2 0-32-4.5-45.7-13.1l-32.6-20.5-6.4-37.7c-0.8-4.8-1.2-9.7-1.2-14.6 0-16.2 4.5-32 13.1-45.6 8.3-13.3 20.2-24.1 34.1-31.2l35.7-18.3m-358.8 73.4c29.4 0 54.5 15 89.2 35.8 23.1 13.8 49.3 29.5 81.3 43.1 15.7 6.7 31.7 11.6 47.6 14.7l36.6 7.2-0.7 0.7c-27.6 27.8-55.7 49.5-83.3 64.6-30.6 16.7-60.8 25.2-89.8 25.2-5.4 0-10.9-0.3-16.4-0.9-20.2-2.2-38.7-7.4-55-15.6-14.5-7.2-27.4-16.8-38.3-28.4-19.5-20.8-32.3-48.5-35.3-76-1.9-17.3 0.3-33.4 6-45.3 6.6-13.8 15.7-16.9 18.6-17.9 14.6-4.8 27.5-7.2 39.5-7.2m484.7 79.1h0.2c42 10.9 77.8 26 106.3 44.6 31.8 20.8 54.5 46.2 67.4 75.6 28.8 65.3 7.7 114-7.5 137.3-10.5 16.2-24.2 29.7-39.6 39.1-13.2 8.1-26.9 12.6-38.6 12.6-8.6 0-15.4-2.4-21-7.3-24.6-21.8-31.7-39.8-35.2-53.1-5.3-20.2-4.9-44.5-4.4-72.6 0.4-26.9 0.9-57.5-3.3-92-2.4-19.2-6.8-37.7-13.3-54.9l-11-29.3m-1.2-505.9c-53.8 0-112.1 23.4-155.6 82.8-51.8 70.8-48.4 163-27.5 244.3-44.2 22.4-74.6 68.4-74.6 121.4 0 7.8 0.7 15.5 1.9 23-12.1-2.4-24.7-6.2-37.7-11.7-78.7-33.4-121.9-82.9-190.1-82.9-16.7 0-34.8 3-55.3 9.8C48 501 78.5 725.9 267 746.4c7.3 0.8 14.6 1.2 21.8 1.2 80.9 0 153-48.5 208.6-104.5 20.9 13.2 45.7 20.8 72.3 20.8 33.2 0 63.6-11.9 87.2-31.6 4.9 13 8.5 27.4 10.5 43.4 12.9 105.6-23.1 176 59.4 249.1 15.4 13.7 34.3 19.9 54.2 19.9 86.5 0 193.5-118.2 131.3-259.2-36.7-83.4-123.1-126.7-206.9-148.5 0.2-3 0.3-6.1 0.3-9.1 0-56-33.8-104-82.1-124.9 7.5-8.2 16.2-16.1 26.2-23.7 85-64 164-68 186-176C849.3 137.2 776 79.4 691.4 79.4z"
                          fill="rgba(255,255,255, 0.6)"
                          p-id="9571"
                        ></path>
                      </svg>
                      <!-- 风速中 -->
                      <svg
                        v-else-if="temp.windspeed == 'middle'"
                        t="1679650045156"
                        class="icon"
                        viewBox="0 0 1024 1024"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        p-id="9424"
                        width="24"
                        height="24"
                      >
                        <path
                          d="M632.7 112.6c18.2 0 36.3 3.7 52.3 10.6 14.2 6.2 26.3 14.9 34.2 24.4 11.8 14.5 9.7 25.2 8.9 28.8-6.6 32.2-18.6 47.4-28.4 57-14.9 14.6-36.1 26.5-60.7 40.1-23.5 13.1-50.2 27.9-78 48.9-12.3 9.3-23.6 19.5-33.5 30.4l-27.9 30.7-1.3-5.2c-10.5-40.5-14.7-77.7-12.4-110.7 2.5-36.4 13.1-67.6 31.5-92.8 15.8-21.6 34.6-37.9 55.9-48.5 18.6-9 38.6-13.7 59.4-13.7M173.2 316.8c1.9 0 3.8 0.2 5.8 0.6 32.2 6.6 47.4 18.6 57 28.4 14.6 14.9 26.5 36.1 40.1 60.7 13.1 23.5 27.9 50.2 48.9 78 6.5 8.6 13.5 16.7 20.8 24.2l37.2 38c-34 9-65.9 13.5-94.9 13.5-21.6 0-41.6-2.6-59.6-7.6-18.9-5.3-36.1-13.6-51-24.5-63.7-46.6-70.6-111.5-55.8-156.7 10.2-31.7 31.9-54.6 51.5-54.6m335.1 100.4l36.9 15.5c20.2 8.4 36.2 24.1 45.2 44l16.6 36.7-17.6 36.2c-7.2 14.9-18.5 27.3-32.7 35.9l-32 19.5 0.8 3-42.1-14.8c-16.2-5.7-30.2-16-40.5-29.9l-20.5-27.5-7.7 2.1 14.7-50.1c6.6-22.5 22.4-41.6 43.3-52.3l35.6-18.3m227.6 75.6c44.3 0 81.5 10.8 110.6 32.1 63.7 46.6 70.6 111.5 55.8 156.7-10.3 31.6-32 54.5-51.6 54.5-1.9 0-3.8-0.2-5.8-0.6-32.2-6.6-47.4-18.6-57-28.4-14.6-14.9-26.5-36.1-40.1-60.7-13.1-23.5-27.9-50.2-48.9-78-9.5-12.6-20-24.1-31.2-34.2l-30.2-27.1 10.4-2.6c31.5-7.7 61.1-11.7 88-11.7M534.6 641.5c11.1 41.2 15.7 79.1 13.6 112.6-2.3 37.3-12.9 69.3-31.7 94.9-15.8 21.6-34.6 37.9-55.9 48.5-18.6 9.2-38.6 13.9-59.4 13.9-18.2 0-36.3-3.7-52.3-10.6-14.2-6.2-26.3-14.9-34.2-24.4-11.8-14.5-9.7-25.2-8.9-28.8 6.6-32.2 18.6-47.4 28.4-57 14.9-14.6 36.1-26.5 60.7-40.1 23.5-13.1 50.2-27.9 78-48.9 10.9-8.2 21.1-17.2 30.1-26.8l31.6-33.3m98.1-578.9c-53.8 0-112.1 23.4-155.6 82.8-52.1 71.2-48.4 163.9-27.2 245.6-32.8 16.9-57.9 46.7-68.4 82.7-5.7-5.8-11.2-12.2-16.6-19.3-64-85-68-164-176-186-5.3-1.1-10.6-1.6-15.7-1.6-100.2 0-170.8 195.1-25.3 301.6 41.5 30.4 90.4 41.8 140.2 41.8 38.7 0 78-6.9 114.7-17.1 16 21.5 38.2 38.2 64 47.2-7 7.3-14.9 14.5-23.9 21.3-85 64-164 68-186 176-13.5 66 59.8 123.8 144.4 123.8 53.8 0 112.1-23.4 155.6-82.8 53.1-72.6 48.2-167.7 25.9-250.4 22.2-13.5 40.1-33.2 51.6-56.7 8.6 7.7 16.9 16.7 24.7 27.1 64 85 68 164 176 186 5.3 1.1 10.6 1.6 15.7 1.6 100.1 0 170.7-195.1 25.3-301.6-41.5-30.4-90.4-41.8-140.2-41.8-33.6 0-67.6 5.2-99.9 13.2-14.1-31.3-39.8-56.2-71.5-69.5 7.6-8.3 16.4-16.4 26.6-24.1 85-64 164-68 186-176 13.4-66-59.8-123.8-144.4-123.8z"
                          fill="rgba(255,255,255, 0.6)"
                          p-id="9425"
                        ></path>
                      </svg>
                      <!-- 风速高 -->
                      <svg
                        v-else-if="temp.windspeed == 'high'"
                        t="1679650064790"
                        class="icon"
                        viewBox="0 0 1024 1024"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        p-id="9716"
                        width="24"
                        height="24"
                      >
                        <path
                          d="M603.7 89c18.2 0 36.3 3.7 52.3 10.6 14.2 6.2 26.3 14.9 34.2 24.4 11.8 14.5 9.7 25.2 8.9 28.8-6.6 32.2-18.6 47.4-28.4 57-14.9 14.6-36.1 26.5-60.7 40.1-23.5 13.1-50.2 27.9-78 48.9-20.4 15.3-37.6 33.1-51.3 52.8l-8.8 12.7c-11.2-40-16.4-77-15.5-110.2 1.2-40.8 12-75.4 32-102.8 15.8-21.6 34.6-37.9 55.9-48.5 18.6-9.1 38.6-13.8 59.4-13.8M204.2 206.7c5.1 0 9.8 1.2 14.2 3.7 28.6 16.2 39.3 32.4 45.5 44.6 9.3 18.7 14 42.5 19.4 70.1 5.2 26.4 11.1 56.4 22.4 89.3 6.5 18.9 15 36.5 25.4 52.4l16.2 24.9c-41.6-1.8-78.4-8.5-109.5-19.9-37.5-13.7-66.4-34.5-86-61.5-18.4-25.5-28.5-52.4-30-80-1.4-23.7 3.7-47.5 14.6-68.8 8.7-17 21-31.9 34.6-41.8 11.4-8.4 23.2-13 33.2-13m567.5 186.4c17 0 33.6 2.6 49.1 7.7 19.3 6.3 36.3 15.3 50.6 26.7 12.7 10.1 23.3 22.1 31.6 35.8 14.7 24.4 21.5 54.1 18.7 81.7-1.8 17.3-7.2 32.6-15.3 43.1-9.3 12.2-18.8 13.2-21.9 13.6-6.2 0.7-12.2 1.1-17.8 1.1-19.3 0-34.9-4.1-50.6-13.4-16.6-9.8-32.8-24.9-51.6-42.3-19.7-18.3-42.1-39.1-70.6-59.1-16.7-11.7-34.4-21.1-52.5-27.9L614.6 450c25.6-16.9 50.8-30.3 75.1-39.7 28.9-11.5 56.5-17.2 82-17.2m-293.4 27.6l31.1 7.9c13.8 3.5 26.7 10.6 37.2 20.4l26 24.2 1.3 35.4c0.1 1.3 0.1 2.4 0.1 3.4 0 13.8-3.1 26.9-9.4 39.1l-17.3 33.8-36.4 10c-7.4 2-15.1 3.1-22.9 3.1-3.9 0-7.8-0.3-11.7-0.8l-33.5-4.5-21.5-26.4c-8.4-10.2-14.3-22.4-17.2-35.2l-7.9-34.8 18.9-30c8.4-13.4 20.4-24.2 34.5-31.2l28.7-14.4m98.5 191.2l1.1 0.8c33.5 26.9 59.7 55.1 77.9 83.6 20.3 31.6 30.5 63.8 30.3 95.7-0.2 55.3-23.9 89-43.7 107.6-23.7 22.2-55.2 35.4-84.3 35.4-11.7 0-22-2.2-29.9-6.4-6.3-3.4-10.7-7.9-13.5-13.9-13.6-29.9-12.8-49.3-10.5-62.8 3.4-20.6 13.6-42.6 25.5-68.1 11.3-24.4 24.2-52.1 34.4-85.4 5.2-17.1 8.6-34.3 9.9-51.3l2.8-35.2M419.3 639c-14.6 39.2-32.4 72.4-52.9 98.6-24.7 31.6-53.5 52.9-85.4 63.1-17.2 5.5-34.1 8.3-50.5 8.3-36.2 0-62.9-13.7-78.9-25.2-20.4-14.6-36.1-34.4-44.4-55.6-4.8-12.3-6.6-24-5.2-33.8 1.1-7.8 4.1-14 9.3-18.7 27.9-25.5 50.5-30.8 76-30.8 15.9 0 33.2 2.1 53.2 4.5 24.7 3 52.7 6.4 84.3 6.4 2.5 0 5 0 7.5-0.1 22.6-0.4 44.3-3.7 64.7-10l22.3-6.7M603.7 39c-53.8 0-112.1 23.4-155.6 82.8-57 77.9-47.2 181.7-20.7 268.4-22.4 11.2-41.2 28.3-54.5 49.3-7.8-11.9-14.6-25.6-20-41.4-34.6-100.6-14-177-109.9-231.3-12.3-7-25.5-10.2-38.8-10.2-90.5 0-189.6 148.8-92.9 282.8 55.5 76.9 154.7 100.2 244.1 102.5 4.7 20.8 14.2 39.8 27.2 55.8-15.2 4.6-32.1 7.5-50.9 7.8-2.2 0-4.4 0.1-6.6 0.1-53.6 0-97-10.9-137.5-10.9-37.1 0-71.8 9.1-109.8 43.9C6.8 703.7 88.6 859 230.6 859c20.7 0 42.7-3.3 65.7-10.7 90.7-29.1 143.5-116.9 173.3-201.5 6 0.8 12.1 1.2 18.4 1.2 12.5 0 24.7-1.7 36.2-4.9-1 12.8-3.5 26.4-7.8 40.5-31.1 101.7-92.7 151.4-47 251.7 15.2 33.3 49.6 49.6 88.8 49.6 79 0 177.5-66.1 178-192.8 0.3-90.3-60-164.5-126.9-218.4 9.5-18.6 14.8-39.6 14.8-61.8 0-1.8 0-3.5-0.1-5.3 13.6 5.1 27.4 12.3 41.3 22 80.6 56.5 110.8 123.9 201.4 123.9 7.4 0 15.2-0.4 23.4-1.4 109.5-12.5 126.4-238.7-53.7-298-21.4-7.1-43.1-10.2-64.7-10.2-68.2 0-135.3 31.4-191.1 69.3-16.4-15.2-36.5-26.5-58.9-32.2 10.1-14.5 23.3-28.5 40.3-41.4 85-64 164-68 186-176C761.6 96.8 688.3 39 603.7 39z"
                          fill="rgba(255,255,255, 0.6)"
                          p-id="9717"
                        ></path>
                      </svg>
                    </template>

                    <!-- SOS -->
                    <svg
                      v-if="temp.sos == 'true'"
                      t="1680169519195"
                      class="icon"
                      viewBox="0 0 1024 1024"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      p-id="11737"
                      width="24"
                      height="24"
                    >
                      <path
                        d="M238.4 508.608a158.336 158.336 0 0 0-78.336-20.608A112.32 112.32 0 0 1 47.872 375.808c0-61.888 50.368-112.256 112.192-112.256 56.256 0 102.784 41.664 110.848 95.744h48.448a160.384 160.384 0 0 0-159.296-143.552A160.32 160.32 0 0 0 0 375.872a160.192 160.192 0 0 0 160.064 160.064c61.888 0 112.192 50.368 112.192 112.32 0 61.76-50.368 112.128-112.192 112.128-51.776 0-95.36-35.264-108.224-83.136H2.688a160.256 160.256 0 0 0 157.376 131.008 160.192 160.192 0 0 0 160.064-160 160 160 0 0 0-81.728-139.648zM942.208 508.608a158.08 158.08 0 0 0-78.336-20.544 112.32 112.32 0 0 1-112.192-112.192c0-61.888 50.304-112.256 112.192-112.256 56.256 0 102.848 41.664 110.848 95.744h48.384a160.256 160.256 0 0 0-159.232-143.616 160.32 160.32 0 0 0-160.064 160.128 160.32 160.32 0 0 0 160.064 160.064c61.888 0 112.256 50.368 112.256 112.32 0 61.76-50.368 112.128-112.256 112.128a112.256 112.256 0 0 1-108.224-83.136h-49.152a160.256 160.256 0 0 0 157.376 131.008 160.192 160.192 0 0 0 160.128-160c0-59.904-33.024-112.256-81.792-139.648zM509.312 806.848c-87.04 0-157.888-67.008-157.888-149.376V365.824c0-82.432 70.848-149.44 157.888-149.44s157.888 67.008 157.888 149.44v291.648c0.064 82.432-70.848 149.376-157.888 149.376z m0-542.592c-60.672 0-110.016 45.568-110.016 101.568v291.648c0 56 49.344 101.504 110.016 101.504s110.016-45.504 110.016-101.504V365.824c0.064-56-49.344-101.568-110.016-101.568z"
                        fill="rgba(255,255,255, 0.6)"
                        p-id="11738"
                      ></path>
                    </svg>

                    <svg
                      v-if="temp.water == 'true'"
                      xmlns="http://www.w3.org/2000/svg"
                      t="1680169519196"
                      class="icon"
                      viewBox="0 0 24 24"
                      version="1.1"
                      p-id="11721"
                      width="24"
                      height="24"
                    >
                      <title>水浸报警，请尽快处理</title>
                      <path
                        d="M10 3.25C10 3.25 4 10 4 14C4 17.31 6.69 20 10 20S16 17.31 16 14C16 10 10 3.25 10 3.25M10 18C7.79 18 6 16.21 6 14C6 12.23 8 8.96 10 6.39C12 8.95 14 12.23 14 14C14 16.21 12.21 18 10 18M20 7V13H18V7H20M18 17H20V15H18V17Z"
                        fill="rgba(255,255,255, 0.6)"
                        p-id="11722"
                      />
                    </svg>
                    <svg
                      v-if="temp.smoke == 'true'"
                      xmlns="http://www.w3.org/2000/svg"
                      t="1680169519197"
                      class="icon"
                      viewBox="0 0 24 24"
                      version="1.1"
                      p-id="11723"
                      width="24"
                      height="24"
                    >
                      <title>烟雾报警，请尽快处理</title>
                      <path
                        d="M17 19V22H15V19C15 17.9 14.1 17 13 17H10C7.2 17 5 14.8 5 12C5 10.8 5.4 9.8 6.1 8.9C3.8 8.5 2 6.4 2 4C2 3.3 2.2 2.6 2.4 2H4.8C4.3 2.5 4 3.2 4 4C4 5.7 5.3 7 7 7H10V9C8.3 9 7 10.3 7 12S8.3 15 10 15H13C15.2 15 17 16.8 17 19M17.9 8.9C20.2 8.5 22 6.4 22 4C22 3.3 21.8 2.6 21.6 2H19.2C19.7 2.5 20 3.2 20 4C20 5.7 18.7 7 17 7H15.8C15.9 7.3 16 7.6 16 8C16 9.7 14.7 11 13 11V13C15.8 13 18 15.2 18 18V22H20V18C20 15.3 18.5 13 16.2 11.8C17.1 11.1 17.7 10.1 17.9 8.9Z"
                        fill="rgba(255,255,255, 0.6)"
                        p-id="11724"
                      />
                    </svg>
                    <svg
                      v-if="temp.gas == 'true'"
                      xmlns="http://www.w3.org/2000/svg"
                      t="1680169519198"
                      class="icon"
                      viewBox="0 0 24 24"
                      version="1.1"
                      p-id="11725"
                      width="24"
                      height="24"
                    >
                      <title>燃气报警，请尽快处理</title>
                      <path
                        d="M16.14 8.79L16.12 8.8C16.35 9.07 16.55 9.39 16.7 9.72L16.79 9.91C17.5 11.6 17 13.55 15.69 14.77C14.5 15.86 12.84 16.15 11.3 15.95C9.84 15.77 8.5 14.85 7.73 13.58C7.5 13.19 7.3 12.75 7.2 12.3C7.07 11.93 7.03 11.57 7 11.2C6.91 9.6 7.55 7.9 8.76 6.9C8.21 8.11 8.34 9.62 9.15 10.67L9.26 10.8C9.4 10.92 9.57 10.96 9.73 10.89C9.88 10.83 10 10.68 10 10.5L9.93 10.28C9.05 7.96 9.79 5.25 11.66 3.72C12.17 3.3 12.8 2.92 13.46 2.75C12.78 4.11 13 5.89 14.09 6.96C14.55 7.43 15.1 7.74 15.58 8.18L16.14 8.79M13.86 13.43L13.85 13.42C14.3 13.03 14.55 12.36 14.53 11.76L14.5 11.44C14.3 10.44 13.43 10.11 12.87 9.38C12.7 9.16 12.55 8.88 12.44 8.6C12.22 9.1 12.2 9.57 12.29 10.11C12.39 10.68 12.62 11.17 12.5 11.76C12.34 12.41 11.83 13.06 10.94 13.27C11.44 13.76 12.25 14.15 13.06 13.87C13.32 13.8 13.65 13.61 13.86 13.43M11 18V19C11 19.55 11.45 20 12 20C12.55 20 13 19.55 13 19V18H15V19C15 19.55 15.45 20 16 20C16.55 20 17 19.55 17 19V18C18.11 18 20 18.9 20 20V22H4V20C4 18.9 5.9 18 7 18V19C7 19.55 7.45 20 8 20C8.55 20 9 19.55 9 19V18H11Z"
                        fill="rgba(255,255,255, 0.6)"
                        p-id="11726"
                      />
                    </svg>

                    <template v-else>
                      <!-- 勿扰静音 -->
                      <svg
                        v-if="temp.dnd == 'true'"
                        t="1680168956885"
                        class="icon"
                        viewBox="0 0 1024 1024"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        p-id="7809"
                        width="24"
                        height="24"
                      >
                        <path
                          d="M 792.371 136.602 c -10.6496 -8.3968 -26.2144 -6.3488 -34.6112 4.3008 L 166.707 897.434 c -8.3968 10.6496 -6.5536 26.2144 4.3008 34.4064 a 24.8218 24.8218 0 0 0 34.6112 -4.3008 L 796.672 171.008 c 8.192 -10.6496 6.3488 -26.0096 -4.3008 -34.4064 Z M 192.102 792.371 l 101.581 -135.578 c 0.6144 -0.8192 0.8192 -1.6384 1.2288 -2.6624 c 0.8192 -1.4336 1.6384 -2.8672 2.2528 -4.5056 c 0.6144 -1.6384 0.8192 -3.2768 1.024 -4.9152 c 0.2048 -1.024 0.6144 -1.8432 0.6144 -2.8672 V 388.506 c 0 -109.773 89.2928 -199.066 199.066 -199.066 c 42.1888 0 82.3296 12.9024 116.531 37.6832 c 11.0592 7.9872 26.4192 5.5296 34.4064 -5.5296 s 5.5296 -26.4192 -5.5296 -34.4064 a 247.398 247.398 0 0 0 -96.0512 -41.984 c 0 -2.6624 -0.2048 -5.5296 -0.8192 -7.9872 c -0.6144 -3.072 -1.6384 -6.3488 -2.8672 -9.216 c -1.2288 -2.8672 -2.8672 -5.7344 -4.5056 -8.3968 c -1.8432 -2.8672 -3.8912 -5.12 -6.144 -7.5776 c -18.432 -18.432 -51.4048 -18.432 -69.8368 0 c -2.4576 2.4576 -4.5056 4.7104 -6.3488 7.5776 c -1.8432 2.6624 -3.072 5.5296 -4.5056 8.3968 c -1.2288 3.072 -2.2528 6.144 -2.6624 9.216 c -0.8192 2.8672 -1.024 5.5296 -1.024 8.192 c -113.254 22.9376 -198.861 123.29 -198.861 243.302 v 245.35 l -96.6656 129.024 a 24.535 24.535 0 0 0 19.6608 39.3216 c 7.3728 -0.2048 14.7456 -3.6864 19.456 -10.0352 Z M 842.752 762.88 l -96.6656 -129.024 V 368.026 c 0 -13.5168 -11.0592 -24.576 -24.576 -24.576 s -24.576 11.0592 -24.576 24.576 v 267.469 c 0 9.6256 3.072 19.0464 8.8064 26.624 l 97.6896 130.253 c 4.9152 6.7584 2.6624 13.1072 1.4336 15.5648 s -5.12 8.192 -13.312 8.192 H 354.918 c -13.5168 0 -24.576 11.0592 -24.576 24.576 s 11.0592 24.576 24.576 24.576 h 41.1648 c 8.8064 48.128 50.9952 84.7872 101.786 84.7872 s 92.7744 -36.6592 101.786 -84.7872 h 191.898 c 24.3712 0 46.4896 -13.5168 57.344 -35.4304 c 10.6496 -21.7088 8.3968 -47.5136 -6.144 -66.9696 Z M 497.869 901.12 c -23.3472 0 -43.2128 -14.9504 -50.9952 -35.6352 h 101.786 A 54.231 54.231 0 0 1 497.869 901.12 Z"
                          p-id="7810"
                          fill="rgba(255,255,255, 0.6)"
                        ></path>
                      </svg>

                      <!-- 请即清理 -->
                      <svg
                        v-else-if="temp.mur == 'true'"
                        t="1680169033748"
                        class="icon"
                        viewBox="0 0 1024 1024"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        p-id="9534"
                        width="24"
                        height="24"
                      >
                        <path
                          d="M786.6 715.9c-5.1 0-10.3-1.3-15.1-4.1L295.4 434.7c-14.3-8.3-19.2-26.7-10.8-41 8.3-14.3 26.7-19.2 41-10.8L801.7 660c14.3 8.3 19.2 26.7 10.8 41-5.6 9.5-15.6 14.9-25.9 14.9z"
                          p-id="9535"
                          fill="rgba(255,255,255, 0.6)"
                        ></path>
                        <path
                          d="M629.3 960c-14.7 0-29.3-4.2-42.1-11.6L186.1 714.7c-40-23.3-53.8-75.1-30.7-115.4l166.4-290.5c15-26.1 42.9-42.4 72.9-42.4 14.7 0 29.3 3.9 42.1 11.4l113.2 66 129-225.2c19.1-33.4 54.8-54.1 93.1-54.1 18.8 0 37.4 5 53.7 14.5 51.1 29.8 68.8 95.9 39.3 147.4L735.9 452l102 59.4c40 23.3 53.8 75 30.7 115.3L702.2 917.4c-14.9 26.1-42.9 42.6-72.9 42.6zM394.7 326.4c-8.6 0-16.5 4.7-20.8 12.2L207.5 629.1c-6.7 11.8-2.8 26.9 8.9 33.6l401.1 233.5c3.7 2.1 7.7 3.2 11.9 3.2 8.6 0 16.5-4.7 20.8-12.2l166.4-290.5c6.7-11.8 2.8-26.9-8.8-33.6L680 488.8c-14.2-8.3-19.1-26.5-10.9-40.8L813 196.6c13.2-23 5.4-52.5-17.4-65.7-7.2-4.2-15.3-6.4-23.5-6.4-16.9 0-32.6 9.2-41 23.9l-144 251.4c-4 6.9-10.5 12-18.3 14.1-7.7 2.1-15.9 1-22.9-3.1l-139.4-81.1c-3.6-2.2-7.6-3.3-11.8-3.3z"
                          p-id="9536"
                          fill="rgba(255,255,255, 0.6)"
                        ></path>
                      </svg>

                      <!-- 门磁报警 -->
                      <svg
                        v-if="temp.doorSensor == 'true'"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="rgba(255,255,255, 0.6)"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0_2174_5615)">
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M7.434 1.13208C6.32943 1.13208 5.434 2.02751 5.434 3.13208V20.8679C5.434 21.9725 6.32943 22.8679 7.434 22.8679H10.6793C11.7838 22.8679 12.6793 21.9725 12.6793 20.8679V3.13208C12.6793 2.02751 11.7838 1.13208 10.6793 1.13208H7.434ZM15.5849 1.13208C14.4803 1.13208 13.5849 2.02751 13.5849 3.13208V20.8679C13.5849 21.9725 14.4803 22.8679 15.5849 22.8679H16.1132C17.2178 22.8679 18.1132 21.9725 18.1132 20.8679V3.13208C18.1132 2.02751 17.2178 1.13208 16.1132 1.13208H15.5849ZM21.4158 5.72276C21.5927 5.52984 21.8794 5.52984 22.0562 5.72276C23.0524 6.80945 24.0002 8.91385 24.0002 11.506C24.0002 14.5964 23.051 16.6667 22.1128 18.202C21.9741 18.429 21.6929 18.4903 21.4848 18.339C21.2767 18.1877 21.2205 17.881 21.3592 17.6539C22.2323 16.2252 23.0945 14.3436 23.0945 11.506C23.0945 9.15824 22.231 7.31067 21.4158 6.42138C21.239 6.22846 21.239 5.91568 21.4158 5.72276ZM1.94395 18.2772C2.12079 18.4701 2.40751 18.4701 2.58435 18.2772C2.76119 18.0843 2.76119 17.7715 2.58435 17.5786C1.76916 16.6893 0.905659 14.8417 0.905659 12.4939C0.905659 9.65629 1.76783 7.77469 2.64093 6.34598C2.77965 6.11898 2.72342 5.81227 2.51533 5.66093C2.30724 5.5096 2.0261 5.57094 1.88737 5.79794C0.949151 7.33321 2.47652e-07 9.40358 0 12.4939C-2.07729e-07 15.0861 0.947816 17.1905 1.94395 18.2772ZM19.6235 8.66693C19.8104 8.48567 20.0967 8.50404 20.2628 8.70795C20.954 9.55618 21.2829 10.5635 21.2829 12.0001C21.2829 13.4367 20.954 14.4441 20.2628 15.2923C20.0967 15.4962 19.8104 15.5146 19.6235 15.3333C19.4366 15.1521 19.4198 14.8398 19.5859 14.6359C20.1023 14.0021 20.3772 13.2438 20.3772 12.0001C20.3772 10.7564 20.1023 9.99809 19.5859 9.36434C19.4198 9.16042 19.4366 8.84818 19.6235 8.66693ZM3.73735 15.2922C3.9035 15.4961 4.18973 15.5145 4.37665 15.3332C4.56357 15.152 4.5804 14.8397 4.41425 14.6358C3.89786 14.0021 3.62297 13.2437 3.62297 12C3.62297 10.7563 3.89786 9.99801 4.41425 9.36425C4.5804 9.16034 4.56357 8.8481 4.37665 8.66684C4.18973 8.48558 3.90351 8.50395 3.73735 8.70786C3.0462 9.5561 2.71731 10.5635 2.71731 12C2.71731 13.4366 3.0462 14.444 3.73735 15.2922Z"
                            fill="rgba(255,255,255, 0.6)"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_2174_5615">
                            <rect width="24" height="24" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                    </template>
                  </div>

                  <!-- 选中 -->
                  <div v-show="temp.checked" class="checked flex-end">
                    <i class="align-start el-icon-success font-xxl primary"></i>
                  </div>
                </div>
                <!-- 设备离线 -->
                <div
                  v-else
                  class="room flex-between flex-col"
                  :class="{
                    rented: temp.rent === 'rented',
                  }"
                  @click="handleOffLine(temp.roomNo)"
                >
                  <p class="num">{{ temp.roomNo }}</p>
                  <div class="off-line flex-center">
                    <svg
                      t="1680163694217"
                      class="icon"
                      viewBox="0 0 1024 1024"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      p-id="2725"
                      width="40px"
                      height="40px"
                    >
                      <path
                        d="M505.6 659.2c-51.2 0-102.4 19.2-134.4 51.2-12.8 12.8-32 12.8-44.8 0-19.2-12.8-12.8-38.4 0-57.6 32-25.6 76.8-44.8 121.6-57.6l57.6 64zM288 448c-44.8 19.2-83.2 44.8-115.2 76.8-12.8 12.8-12.8 38.4 0 51.2 12.8 12.8 38.4 12.8 44.8 0 38.4-32 76.8-57.6 121.6-76.8L288 448zM128 288c-38.4 25.6-83.2 57.6-115.2 96-12.8 12.8-12.8 38.4 0 51.2 12.8 12.8 32 12.8 44.8 0 38.4-38.4 76.8-70.4 121.6-96L128 288z m864 96C864 256 691.2 179.2 505.6 179.2c-76.8 0-147.2 12.8-211.2 32l57.6 57.6c44.8-12.8 96-19.2 153.6-19.2 172.8 0 326.4 70.4 441.6 179.2 12.8 19.2 32 19.2 44.8 0 12.8-6.4 19.2-32 0-44.8z m-486.4 12.8H480l76.8 76.8c83.2 6.4 166.4 44.8 224 102.4 12.8 12.8 32 12.8 44.8 0 19.2-12.8 19.2-38.4 0-51.2-83.2-76.8-198.4-128-320-128z m0 409.6c-38.4 0-70.4 32-70.4 70.4 0 38.4 32 70.4 70.4 70.4s70.4-32 70.4-70.4c0-44.8-32-70.4-70.4-70.4z m192-121.6l-64-64L480 467.2l-64-64L300.8 288l-57.6-57.6-38.4-38.4c-19.2-12.8-38.4-12.8-51.2 0-12.8 12.8-12.8 38.4 0 51.2l19.2 19.2 51.2 51.2 140.8 140.8 25.6 25.6 288 288c12.8 12.8 38.4 12.8 51.2 0 12.8-12.8 12.8-38.4 0-51.2l-32-32z"
                        fill="rgba(255,255,255, 0.5)"
                        p-id="2726"
                      ></path>
                    </svg>
                  </div>
                </div>
              </li>
            </ul>
          </transition>
        </li>
      </ul>

      <!-- 暂无数据 -->
      <el-empty v-if="building.floorData.length === 0"></el-empty>
    </section>
  </div>
</template>

<script>
export default {
  name: "FloorRoomItem",

  props: {
    list: {
      type: Array,
      default() {
        return [];
      },
    },

    theme: {
      type: String,
      default: "",
    },

    multiple: {
      type: Boolean,
      default: false,
    },
    // 允许有人控制房间
    someOneCanControl: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      builds: [],
      col: 10,
    };
  },

  watch: {
    list: {
      immediate: true,
      handler(val) {
        const data = JSON.parse(JSON.stringify(val));
        data.forEach((item) => {
          item.floorData.forEach((temp) => {
            this.$set(temp, "checked", false);
            this.$set(temp, "show", true);
            temp.roomData.forEach((obj) => {
              this.$set(obj, "checked", false);
              // 查询上次楼层展开和选中情况,防止更新数据折叠起来
              this.builds.forEach((build) => {
                if (build.buildingName === item.buildingName) {
                  for (let floor of build.floorData) {
                    if (floor.floorName === temp.floorName) {
                      temp.show = floor.show;
                      temp.checked = floor.checked;
                      for (const room of floor.roomData) {
                        if (room.roomNo === obj.roomNo) {
                          obj.checked = room.checked;
                          break;
                        }
                      }
                    }
                  }
                }
              });
            });
          });
        });
        this.builds = data;
      },
    },
  },

  created() {
    if (window.innerWidth < 1500) {
      this.col = 8;
    }
  },

  methods: {
    // 点击离线房间
    handleOffLine(num) {
      this.$message.error(`设备离线 - ${num}`);
    },
    // 点击在线房间
    handleItem(temp) {
      if (temp.hotelUsable === "off") {
        this.$message.error(`房间设备已停用 - ${temp.roomNumber}`);
      }
      // 如果是多选
      else if (this.multiple) {
        // 无人或有权限允许控制
        if (temp.identity !== "noPeople" && !this.someOneCanControl) {
          this.$message.error("房间有人，不可控制");
        } else {
          temp.checked = !temp.checked;
          this.totalChecked();
        }
      } else {
        this.$emit("open", temp);
      }
    },
    // 折叠
    toggleShow(item) {
      item.show = !item.show;
    },

    // 全选楼层房间
    checkFloorRoom(val, floor) {
      let checkNum = 0;
      floor.roomData.forEach((room) => {
        // 在线、无人的房间才能被选中
        if (
          room.basicstatus === "off" ||
          (room.identity !== "noPeople" && !this.someOneCanControl)
        ) {
          room.checked = false;
        } else {
          room.checked = val;
          if (val) checkNum++;
        }

        if (val && checkNum === 0) {
          this.$message.error("该楼层没有可控房间");
        }
      });
      this.totalChecked();
    },

    // 统计选中情况
    totalChecked() {
      const checkedRooms = [];
      let checkedBuildNum = 0;
      this.builds.forEach((build) => {
        let checkedFloorNum = 0;
        build.floorData.forEach((floor) => {
          let checkedRoomNum = 0;
          let otherRoomNum = 0;
          floor.roomData.forEach((room) => {
            // 为了统计全选选中、离线、有人都属于勾选
            if (
              room.basicstatus === "off" ||
              (room.identity !== "noPeople" && !this.someOneCanControl)
            ) {
              otherRoomNum++;
            }
            if (room.checked) {
              checkedRoomNum++;
              checkedRooms.push(room);
            }
          });
          let totalCheck = checkedRoomNum + otherRoomNum;
          if (totalCheck === floor.roomData.length) {
            checkedFloorNum++;
          }
          floor.checked =
            checkedRoomNum > 0 && totalCheck === floor.roomData.length;
        });

        if (checkedFloorNum === build.floorData.length) {
          checkedBuildNum++;
        }
      });

      this.$emit(
        "checked-all",
        checkedBuildNum > 0 && checkedBuildNum === this.builds.length
      );
      this.$emit("change", checkedRooms);
    },
    // 父组件调用全选
    checkedAll(checked) {
      const checkedRooms = [];
      this.builds.forEach((build) => {
        build.floorData.forEach((floor) => {
          let checkedRoomNum = 0;
          floor.roomData.forEach((room) => {
            if (
              room.basicstatus === "off" ||
              (room.identity !== "noPeople" && !this.someOneCanControl)
            ) {
              room.checked = false;
            } else {
              room.checked = checked;
              if (checked) {
                checkedRoomNum++;
                checkedRooms.push(room);
              }
            }
          });

          floor.checked = checked && checkedRoomNum === floor.roomData.length;
        });
      });
      this.$emit("change", checkedRooms);
      return checkedRooms.length;
    },
  },
};
</script>
<style scoped lang="scss">
.floor {
  border-radius: 8px;
  background: linear-gradient(to bottom, #064086, #054796);
  list-style: none;
  &.black {
    background: linear-gradient(to bottom, #1c1c1f, #1f1e23);
  }

  .pointer {
    user-select: none;
  }

  .list {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    padding-left: 16px;
    overflow: hidden;
    .item {
      padding-right: 16px;
      padding-bottom: 16px;
      list-style: none;
      flex-shrink: 0;
      flex-grow: 0;
      width: 10%;
      .room {
        position: relative;
        min-height: 104px;
        border-radius: 5px;
        border: 1px solid rgba(18, 165, 255, 0.1);
        background: radial-gradient(
          100% 150% at 50% -22%,
          rgba(72, 185, 255, 0.26) 0%,
          rgba(114, 202, 255, 0) 72%,
          rgba(108, 199, 255, 0.04) 99%,
          rgba(108, 199, 255, 0.04) 100%
        );
        box-shadow: 0px 10px 10px 0px rgba(0, 0, 0, 0.1);
        cursor: pointer;

        .num {
          padding: 4px 4px 0 4px;
          text-align: center;
          line-height: 28px;
          font-size: 16px;
          border-radius: 0px 0px 5px 5px;
          color: #fff;
        }
        // 温度
        .she-shi-du {
          user-select: none;
          margin-top: 2px;
          line-height: 1;
          font-size: 20px;
          color: rgba(255, 255, 255, 0.6);
        }
        .she-shi-du_small {
          user-select: none;
          margin-top: 2px;
          line-height: 1;
          font-size: 15px;
          color: rgba(255, 255, 255, 0.6);
        }
        // 状态图标
        .icons {
          min-height: 32px;
          svg {
            margin: 0 4px 8px;
          }
        }

        // 选中
        .checked {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          background: rgba(0, 0, 0, 0.5);
        }

        // 离线
        .off-line {
          padding-bottom: 20px;
        }

        // 已租
        &.rented {
          border: 1px solid rgba(56, 155, 150, 0.3);
          background: radial-gradient(
            120% 120% at 50% 10%,
            rgb(56, 155, 150) 0%,
            rgb(14, 69, 97) 100%
          );
        }
        @keyframes identifier {
          0% {
            background: radial-gradient(
              120% 120% at 50% 10%,
              rgb(245, 108, 108) 0%,
              rgb(136, 25, 25) 100%
            );
          }

          100% {
            background: radial-gradient(
              120% 120% at 50% 10%,
              rgb(160, 35, 35) 0%,
              rgb(78, 7, 7) 100%
            );
          }
        }
        // help0
        &.sos {
          animation: identifier 0.5s linear infinite;
          border: 1px solid rgba(136, 25, 25, 0.3);
        }

        &:hover {
          box-shadow: 0 1px 12px 0px rgba(0, 0, 0, 0.4);
        }
        &:active {
          opacity: 0.8;
        }
      }
    }
  }

  @media screen and (max-width: 1500px) {
    .list .item {
      width: 12.5%;
    }
  }
}

.slider1-enter-active,
.slider1-leave-active {
  transition: all 0.3s ease-out;
  max-height: 120px;
}
.slider1-enter, .slider1-leave-to /* .fade-leave-active below version 2.1.8 */ {
  max-height: 0;
  overflow: hidden;
}
.slider2-enter-active,
.slider2-leave-active {
  transition: all 0.3s ease-out;
  max-height: 240px;
}
.slider2-enter, .slider2-leave-to /* .fade-leave-active below version 2.1.8 */ {
  max-height: 0;
  overflow: hidden;
}
.slider3-enter-active,
.slider3-leave-active {
  transition: all 0.3s ease-out;
  max-height: 360px;
}
.slider3-enter, .slider3-leave-to /* .fade-leave-active below version 2.1.8 */ {
  max-height: 0;
  overflow: hidden;
}
.slider4-enter-active,
.slider4-leave-active {
  transition: all 0.3s ease-out;
  max-height: 480px;
}
.slider4-enter, .slider4-leave-to /* .fade-leave-active below version 2.1.8 */ {
  max-height: 0;
  overflow: hidden;
}
.slider5-enter-active,
.slider5-leave-active {
  transition: all 0.3s ease-out;
  max-height: 600px;
}
.slider5-enter, .slider5-leave-to /* .fade-leave-active below version 2.1.8 */ {
  max-height: 0;
  overflow: hidden;
}
</style>
